export default "__VITE_ASSET__BbNV4Xpx__"